var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5242 19.3361V17.455C18.5242 16.4572 18.1279 15.5003 17.4223 14.7948C16.7168 14.0892 15.7599 13.6929 14.7621 13.6929H7.23775C6.23996 13.6929 5.28304 14.0892 4.5775 14.7948C3.87196 15.5003 3.47559 16.4572 3.47559 17.455V19.3361",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.93057C13.0777 9.93057 14.7621 8.2462 14.7621 6.16841C14.7621 4.09063 13.0777 2.40625 11 2.40625C8.92217 2.40625 7.23779 4.09063 7.23779 6.16841C7.23779 8.2462 8.92217 9.93057 11 9.93057Z",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRed);
export default __webpack_public_path__ + "static/media/UserRed.163d44a411b052604c8529ba2a8ae572.svg";
export { ForwardRef as ReactComponent };